import { render, staticRenderFns } from "./CompanyPros.vue?vue&type=template&id=bcc84f22&scoped=true"
import script from "./CompanyPros.vue?vue&type=script&lang=ts"
export * from "./CompanyPros.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc84f22",
  null
  
)

export default component.exports